import React from 'react'
import styled from 'styled-components'
import media from '../../utils/media'
import Text from '../../utils/Text'

const Container = styled.div`
  width: 100%;
  max-width: 700px;
  /* margin: 30px auto 100px; */
  position: relative;
  ${media.mobileL`
    padding: 0 17px;
    margin-bottom: 60px;
  `}
`

const AnswerContainer = styled.div`
  min-height: 340px;
`

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: row;
  text-align: left;
  margin-bottom: 50px;
  ${media.mobileL`
    margin-bottom: 30px;
  `}
`

const Number = styled.p`
  font-family: Muli, sans-serif;
  font-size: 25px;
  font-weight: 600;
  line-height: 1.18;
  color: #ffae45;
`

const Title = styled.div`
  margin-left: 30px;
  span {
    font-size: 25px;
    font-weight: normal;
    line-height: 1.18;
  }
`

export default function Question({ children, config }) {
  const { id, question } = config

  return (
    <Container>
      <QuestionContainer>
        <Number>
          <Text id={id} />
        </Number>
        <Title>
          <Text id={question} />
        </Title>
      </QuestionContainer>
      <AnswerContainer>{children}</AnswerContainer>
    </Container>
  )
}
